"use strict";import{html as i}from"@cisco-u/base";export function twitterIcon({height:r=16,width:l=16,hidden:e=!1,title:o="Twitter",type:a="",hover:t=!1}={}){return a==="dark"?i`<svg
      width=${l}
      height=${r}
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="${e?"true":"false"}"
      aria-label="${o}"
      role="img"
      style=${t?"color: var(--color-blue-primary);":"color: var(--color-white);"}
    >
      <circle cx="16" cy="16" r="16" fill="currentColor" />
      <path
        d="M8.00113 8.13482H12.7333L17.1073 14.0184L22.5519 8L23.8455 8.02247L17.7522 14.8648L24.0011 23.2689H19.2709L15.1424 17.786L10.0991 23.4037H8.82606L14.5162 16.9846L8.00113 8.13482ZM12.287 9.00369H9.78786L19.7865 22.3776H22.2406L12.287 9.00369Z"
        fill="#1B1C1D"
      />
    </svg>`:i`<svg
    width=${l}
    height=${r}
    viewBox="0 0 32 32"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="${e?"true":"false"}"
    aria-label="${o}"
    role="img"
    style=${t?"color: var(--color-blue-primary);":"color: var(--color-gray-100);"}
  >
    <circle cx="16" cy="16" r="16" fill="currentColor" />
    <path
      d="M8.00113 8.13482H12.7333L17.1073 14.0184L22.5519 8L23.8455 8.02247L17.7522 14.8648L24.0011 23.2689H19.2709L15.1424 17.786L10.0991 23.4037H8.82606L14.5162 16.9846L8.00113 8.13482ZM12.287 9.00369H9.78786L19.7865 22.3776H22.2406L12.287 9.00369Z"
      fill="#F7F5F4"
    />
  </svg>`}
//# sourceMappingURL=twitter.js.map
